import { Modal, Table } from '@faceup/ui-base'
import { fuAdminsMock, mockCredentialTableColumns } from './loginMockUsers'

type TestAccountsModalProps = {
  open: boolean
  setOpen: (show: boolean) => void
  setEmail: (email: string) => void
  setPassword: (password: string) => void
  login: () => void
}

export const TestAccountsModal = (props: TestAccountsModalProps) => {
  const onRowClick = (email: string) => {
    props.setEmail(email)

    if (
      import.meta.env.VITE_ENVIRONMENT === 'development' ||
      import.meta.env.VITE_ENVIRONMENT === 'preview'
    ) {
      props.setPassword(import.meta.env.VITE_MOCK_ACCOUNT_PASSWORD || '')
      props.login()
    }

    props.setOpen(false)
  }

  return (
    <Modal open={props.open} onClose={() => props.setOpen(false)} width={720}>
      <Table
        title='Users'
        shadow
        pagination={{ defaultPageSize: 20 }}
        dataSource={fuAdminsMock}
        columns={mockCredentialTableColumns}
        rowKey='email'
        onRow={record => ({
          onClick: () => onRowClick(record.email),
        })}
      />
    </Modal>
  )
}
